// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import * as angular from 'angular';
import { app } from '../../app';
import { resolve } from '../../init/store';
import { isRadius } from '../../models/application-types';

app.service('AddApplicationModal', modal);

/** @ngInject */
function modal($uibModal) {
    return appType => {
        return $uibModal.open({
            templateUrl: require('./sp-add-application-modal.html'),
            controller
        }).result;

    /** @ngInject */
    function controller(
        $rootScope,
        $scope,
        $state,
        $uibModalInstance,
        AddNewApplicationResource,
        DomainsService,
    ) {
        $scope.companyId = resolve.companyId;
        $scope.isRadius = isRadius(appType.slug);
        const is = $scope.is = (...slugs) => slugs.includes(appType.slug);

                        $scope.applicationRequest = {};
                        $scope.domainType='0';
                        $scope.tempDomainNames= {
                                computerProtectionADDomainName:null,
                                computerProtectionLDAPDomainName:null
                        };
                        $scope.noSelectExistingDirectory=false;
                        $scope.selectedCompanyAdDomain = null;
                        $scope.selectedAppType = appType;
                        $scope.selectedFederatedDomain = null;
                        $scope.showStaticPasswordForApp = showStaticPasswordForApp();

                        $scope.federated_domains = DomainsService.query({
                            companyId : $scope.companyId
                        });

                        AddNewApplicationResource.getApplicationConfigParameters(
                            $scope.companyId,
                            $scope.selectedAppType.id
                        ).then(function(data) {
                            if (is('computer-login')
                                    && (!data.companyAdDomains || !data.companyAdDomains.length)) {
                                $scope.domainType='1';
                                $scope.noSelectExistingDirectory=true;
                            }

                            $scope.ssoSupported = data.ssoSupported;
                            $scope.ssoEditable = data.ssoEditable;
                            $scope.ssoPostUrlEditable = data.ssoPostUrlEditable;

                            $scope.applicationRequest = {
                                applicationRunningStatus : false,
                                otp : $scope.selectedAppType.otpSupported,
                                staticPassword : showStaticPasswordForApp(),
                                instantLogin : $scope.selectedAppType.instantLoginSupported,
                                instantRegistration : $scope.selectedAppType.instantRegistrationSupported,
                                blueLoginEnabled : $scope.selectedAppType.bluePassSupported,
                                applicationName : data.applicationDefaultName,
                                applicationType : $scope.selectedAppType.id,
                                mobileApplicationEnabled : false,
                                mobAppSettings : {
                                    iosEnabled : true,
                                    androidEnabled : true
                                },
                                applicationSecDomain : '',
                                ssoEnabled : $scope.ssoSupported && !$scope.ssoPostUrlEditable,
                                autoAddUser: is('owa'),
                                pushlogin: $scope.selectedAppType.pushLoginSupported,
                                storePasswordOnServer : true,
                                pendingAssignedAccountLoginSetting : 'REJECT',
                                notAssignedAccountLoginSetting : 'REJECT_ALWAYS',
                                notExistAccountLoginSetting : 'REJECT_ALWAYS',
                                computerProtectionDomainIsForLdap : false,
                                computerProtectionDomainName : null,
                                computerProtectionNetbiosName : null,
                                offlineLoginEnabledForUnprotectedAccount : false
                            };

                            $scope.companyAdDomains = data.companyAdDomains;

                            if($scope.selectedFederatedDomain){
                                $scope.applicationRequest.domainId = $scope.selectedFederatedDomain.id;
                            }

                            setAdDomainIfOnlyOne();

                            $scope.configDTO = data.configDTO;

                            $scope.configValidation = [];
                            if ($scope.configDTO && $scope.configDTO.appConfig != null) {
                                angular.forEach($scope.configDTO.appConfig.elements
                                , function(value, key) {
                                    if (!value.validations) {
                                        $scope.configValidation.push(/.*/);
                                    }
                                    angular.forEach(value.validations
                                    , function(value, key) {
                                        if (value.type == "url") {
                                            $scope.configValidation.push($rootScope.webPattern);
                                        } else if (value.type == "email") {
                                            $scope.configValidation.push($rootScope.emailPattern);
                                        } else {
                                            $scope.configValidation.push(/.*/);
                                        }
                                    });
                                });
                            }
                        });

                    function showStaticPasswordForApp() {
                        return is('custom');
                    }

                    $scope.save = function() {
                        if (is('computer-login', 'computer-protection-without-ad')) {
                            Object.assign($scope.applicationRequest, {
                                remoteLoginEnabled: true,
                                remoteLockEnabled: true,
                                rememberMeEnabled: true,
                                autoLoginEnabled: true,
                                upgradeNotificationEnabled: true
                            });
                        }
                        var applicationAndConfigDTO = {
                            configDTO : $scope.configDTO,
                            applicationRequest : $scope.applicationRequest
                        };

                        if (is('office-365') && !$scope.selectedFederatedDomain) {
                            return;
                        }

                        AddNewApplicationResource
                            .createNonDomainApp($scope.companyId, applicationAndConfigDTO)
                            .then(app => $state.go('company.manage-application', {appId: app.id}))
                    }

                    $scope.ilOrProximityCheck = function() {
                        if ($scope.applicationRequest.instantLogin
                                || $scope.applicationRequest.blueLoginEnabled) {
                            $scope.applicationRequest.otp = true;
                        }
                    }

                   $scope.setNewRequestDomainName= function(newValue) {
                       $scope.applicationRequest.computerProtectionDomainName=newValue;
                   }
                   var setAdDomainIfOnlyOne = function () {
                        if ($scope.companyAdDomains && $scope.companyAdDomains.length == 1) {
                            var domain = $scope.companyAdDomains[0];
                            $scope.selectedCompanyAdDomain = domain;
                            $scope.applicationRequest.activeDirectoryDomainId = domain.id;
                        }
                    }
                    $scope.changeComputerDomainType = function(computerDomainType) {
                        $scope.domainType=computerDomainType;
                        $scope.applicationRequest.computerProtectionNetbiosName=null;
                        $scope.applicationRequest.computerProtectionDomainName=null;
                        $scope.tempDomainNames.computerProtectionADDomainName=null;
                        if(computerDomainType=='2') {
                            $scope.applicationRequest.computerProtectionDomainIsForLdap=true;
                            $scope.applicationRequest.activeDirectoryDomainId=null;
                            $scope.selectedCompanyAdDomain=null;
                        } else {
                            $scope.tempDomainNames.computerProtectionLDAPDomainName=null;
                            $scope.applicationRequest.computerProtectionDomainIsForLdap=false;
                            if(computerDomainType=='1') {
                                $scope.applicationRequest.activeDirectoryDomainId=null;
                                $scope.selectedCompanyAdDomain=null;
                            } else {
                                setAdDomainIfOnlyOne();
                            }
                        }
                    }

                    $scope.selectCompanyAdDomain = function(domain) {
                        $scope.selectedCompanyAdDomain = domain;
                        $scope.applicationRequest.activeDirectoryDomainId = domain.id;
                    }
                    $scope.selectFederatedDomain = function(domain) {
                        $scope.selectedFederatedDomain = domain;
                        $scope.applicationRequest.domainId = domain.id;
                    }

                    $scope.dismiss = () => $uibModalInstance.dismiss();

                    $scope.addUpdateApplicationModalBodyTemplateUrl = require('./add-update-application-modal-body.html');
                }
    }
}



// WEBPACK FOOTER //
// ./src/portal/modals/add-update-application/sp-add-application-modal.directive.js